/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u30m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Running a 30-minute focused study or work block.`)
};

const es_timer_u30m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realizar un bloque de estudio o trabajo enfocado de 30 minutos.`)
};

const de_timer_u30m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einen fokussierten 30-Minuten-Lern- oder Arbeitsblock absolvieren.`)
};

const nl_timer_u30m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een geconcentreerd studie- of werkblok van 30 minuten draaien.`)
};

const fr_timer_u30m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effectuer un bloc de 30 minutes d’étude ou de travail concentré.`)
};

const it_timer_u30m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fare un blocco di studio o lavoro concentrato di 30 minuti.`)
};

const pt_br2_timer_u30m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer um bloco focado de estudo ou trabalho de 30 minutos.`)
};

const pt_timer_u30m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer um bloco de estudo ou trabalho focado de 30 minutos.`)
};

const ja_timer_u30m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30分間の集中した勉強・作業セッションを行う。`)
};

const zh_timer_u30m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`进行一次30分钟的专注学习或工作时段。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u30m_use1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u30m_use1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u30m_use1", locale)
	if (locale === "en") return en_timer_u30m_use1(inputs)
	if (locale === "es") return es_timer_u30m_use1(inputs)
	if (locale === "de") return de_timer_u30m_use1(inputs)
	if (locale === "nl") return nl_timer_u30m_use1(inputs)
	if (locale === "fr") return fr_timer_u30m_use1(inputs)
	if (locale === "it") return it_timer_u30m_use1(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u30m_use1(inputs)
	if (locale === "pt") return pt_timer_u30m_use1(inputs)
	if (locale === "ja") return ja_timer_u30m_use1(inputs)
	return zh_timer_u30m_use1(inputs)
};